import React from 'react';

import {
  IconBan,
  IconCalendarEvent,
  IconCircleCheck,
  IconClock,
  IconEdit,
  IconFlag,
  IconPlayerPlay,
} from '@tabler/icons-react';

export const PROJECT_STATUS_COLORS: Record<string, string> = {
  draft: 'gray',
  pending: 'orange',
  planning: 'violet',
  active: 'green',
  completed: 'indigo',
  cancelled: 'red',
  lost: 'dark',
  bidding: 'yellow',
  tender: 'cyan',
};

export const PROJECT_STATUS_ICONS: Record<string, React.ElementType> = {
  draft: IconEdit,
  pending: IconClock,
  planning: IconCalendarEvent,
  active: IconPlayerPlay,
  completed: IconCircleCheck,
  cancelled: IconBan,
  lost: IconFlag,
};

export function getStatusColor(status: string): string {
  return PROJECT_STATUS_COLORS[status] ?? 'gray';
}

export function getStatusIcon(status: string): React.ElementType {
  return PROJECT_STATUS_ICONS[status] ?? IconEdit;
}
